import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';

export const sessionZoomSchema = z.object({
  sessionId: z.string(),
  attendeeUrl: z.string().nullable(),
  hostUrl: z.string().nullable(),
  recordingUrls: z.array(z.string()).nullable(),
  zoomUuid: z.string().nullable(),
  startedAt: z.array(z.instanceof(Temporal.Instant)),
  endedAt: z.array(z.instanceof(Temporal.Instant)),
  coachJoinAt: z.array(z.instanceof(Temporal.Instant)),
  coachLeaveAt: z.array(z.instanceof(Temporal.Instant)),
});

export type SessionZoom = z.infer<typeof sessionZoomSchema>;

export const updateSessionZoomOptionSchema = z.object({
  startedAt: z.array(z.instanceof(Temporal.Instant)).optional(),
  endedAt: z.array(z.instanceof(Temporal.Instant)).optional(),
  coachJoinAt: z.array(z.instanceof(Temporal.Instant)).optional(),
  coachLeaveAt: z.array(z.instanceof(Temporal.Instant)).optional(),
  hostUrl: z.string().nullable().optional(),
  attendeeUrl: z.string().nullable().optional(),
  zoomUuid: z.string().nullable().optional(),
});
export type UpdateSessionZoomOption = z.infer<typeof updateSessionZoomOptionSchema>;

export const createSessionZoomOptionSchema = z.object({
  sessionId: z.string(),
  startedAt: z.array(z.instanceof(Temporal.Instant)),
  endedAt: z.array(z.instanceof(Temporal.Instant)),
  coachJoinAt: z.array(z.instanceof(Temporal.Instant)),
  coachLeaveAt: z.array(z.instanceof(Temporal.Instant)),
  hostUrl: z.string().nullable(),
  attendeeUrl: z.string().nullable(),
  zoomUuid: z.string().nullable(),
});
export type CreateSessionZoomOption = z.infer<typeof createSessionZoomOptionSchema>;

export const completedSessionWithCoachEmailSchema = z.object({
  id: z.string(),
  start: z.date(),
  end: z.date(),
  coachId: z.string(),
  coachEmail: z.string(),
  zoomUuids: z.array(z.string()).nullable(),
});
export type completedSessionWithCoachEmail = z.infer<typeof completedSessionWithCoachEmailSchema>;

// Type definitions for Zoom recordings API response
export const zoomRecordingFileSchema = z.object({
  deleted_time: z.string().optional(),
  download_url: z.string().optional(),
  file_path: z.string().optional(),
  file_size: z.number().optional(),
  file_type: z.string().optional(),
  file_extension: z.string().optional(),
  id: z.string().optional(),
  meeting_id: z.string().optional(),
  play_url: z.string().optional(),
  recording_end: z.string().optional(),
  recording_start: z.string().optional(),
  recording_type: z.string().optional(),
  status: z.string().optional(),
});
export type ZoomRecordingFile = z.infer<typeof zoomRecordingFileSchema>;

export const zoomMeetingRecordingSchema = z.object({
  account_id: z.string().optional(),
  duration: z.number().optional(),
  host_id: z.string().optional(),
  id: z.number().optional(),
  recording_count: z.number().optional(),
  start_time: z.string().optional(),
  topic: z.string().optional(),
  total_size: z.number().optional(),
  type: z.string().optional(),
  uuid: z.string().optional(),
  recording_play_passcode: z.string().optional(),
  auto_delete: z.boolean().optional(),
  auto_delete_date: z.string().optional(),
  recording_files: z.array(zoomRecordingFileSchema).optional(),
});
export type ZoomMeetingRecording = z.infer<typeof zoomMeetingRecordingSchema>;

export const zoomRecordingsResponseSchema = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
  next_page_token: z.string().optional(),
  page_count: z.number().optional(),
  page_size: z.number().optional(),
  total_records: z.number().optional(),
  meetings: z.array(zoomMeetingRecordingSchema).optional(),
});
export type ZoomRecordingsResponse = z.infer<typeof zoomRecordingsResponseSchema>;
